export type LegalInfo = {
  company: string;
  address: string;
};

export const BUMPY_GROUP: LegalInfo = {
  company: 'MV Bumpy Group Limited',
  address: 'Strovolou 77, 4th floor office 401, 2018 Nicosia, Cyprus',
};

export const BUMPY_INC: LegalInfo = {
  company: 'Bumpy Inc.',
  address: '1007 N Orange St. 4th Floor, Wilmington, DE19801, USA',
};
